import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return "Une erreur est survenue";
};

export const imgUrl = (path) => (path ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}` : null);

export default api;
